'use strict';

exports.__esModule = true;
var sym = typeof Symbol === 'function' ? Symbol : function (id) {
  return '@@revalidate/' + id;
};

exports.default = sym;


//////////////////
// WEBPACK FOOTER
// ./node_modules/revalidate/lib/internal/sym.js
// module id = 2217
// module chunks = 204